module.exports = __webpack_public_path__ + "img/CTBC Indonesia.8824aaf1.png";